module.exports = __webpack_public_path__ + "img/pocket-5_en.0dc9f69.jpg";